import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IStepsResource, IStepsResourceContent } from 'src/shared/models';

const {
  STEPS_DESCRIPTION,
  STEPS_CARD_CONTENT,
  STEPS_CARD_IMAGE,
  STEPS_CARD_NAME,
  STEPS_CARD_IMAGE_DESKTOP,
  STEPS_CARD_SHOW_NUMBERS,
  STEPS_CARD_LINK,
  STEPS_CARD_TEXT_LINK,
} = ResourceTypeDetailEnum;

const getStepsContent = ({
  name,
  resourceDetailList,
}: IResourceList): IStepsResourceContent => {
  let product = { title: name } as IStepsResourceContent;
  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case STEPS_CARD_CONTENT:
          product = {
            ...product,
            content: value,
          };
          break;
        case STEPS_CARD_IMAGE:
          product = {
            ...product,
            image: value,
          };
          break;
        case STEPS_CARD_IMAGE_DESKTOP:
          product = {
            ...product,
            imageDesktop: value,
          };
          break;
        case STEPS_CARD_LINK:
          product = {
            ...product,
            link: value,
          };
          break;
        case STEPS_CARD_NAME:
          product = {
            ...product,
            name: value,
          };
          break;
        case STEPS_CARD_SHOW_NUMBERS:
          product = {
            ...product,
            showNumber: value === 'true' ? true : false,
          };
          break;
        case STEPS_CARD_TEXT_LINK:
          product = {
            ...product,
            textLink: value,
          };
          break;
      }
    });
  return { ...product };
};

export const buildChallengeSteps = (
  resource: IResourceList
): IStepsResource => {
  const {
    resourceDetailList,
    name: title,
    idResource,
    resourceList,
  } = resource;
  let item: IStepsResource;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case STEPS_DESCRIPTION:
          item = {
            ...item,
            description: value,
          };
          break;
      }
    });

  const arrContent: IStepsResourceContent[] =
    resourceList?.map((resource) => getStepsContent(resource)) || [];

  return { ...item, title, arrContent, idResource };
};
